export default "__VITE_ASSET__0bb896d5__"